<template>
    <div>
        <!-- <div v-if="$store.getters.isAdmin" class="container" >
            <div class="flex flex-wrap p-1" >
                <div class="p-1" >
                    <div class="nav_item px-3 py-2 font-medium rounded cursor-pointer" :class="{ 'active shadow' : indexPage == 0 }" @click="indexPage = 0" > {{ "your_balance" | t }}  </div>
                </div>
                <div class="p-1" >
                    <div class="nav_item px-3 py-2 font-medium rounded cursor-pointer" :class="{ 'active shadow' : indexPage == 1 }" @click="indexPage = 1" > {{ "list_balances" | t }} </div>
                </div>
            </div>
        </div>
        <si-progress-bar v-if="loading.page" /> -->
        <div  class="container" >
            <div v-if="indexPage == 0" class="flex flex-wrap w-full" >
                <div class="md:w-7/12 w-full md:p-2 p-1  mb-3"  >
                    <div class="bg-white rounded shadow p-5 flex flex-wrap" >

                        <div class="font-semibold" position="left"> {{ 'balance_amount' | t }} </div>
                        <div class="flex flex-wrap p-1 content-start m-auto md:w-11/12 w-full">
                            <div v-for="(item, index) in [5,10,50,100,200,300]" :key="index" class="p-1 md:w-1/6 w-1/2" @click="amount = item" >
                                <div class="card_method p-2 font-medium text-center relative" :class="{ 'active': amount ==  item }" >
                                    {{ item }} <small class="text-xs">$</small> 
                                </div>
                            </div>
                            <div class="flex items-center mx-2 justify-between">
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
              <span 
                class="text-xs text-primary-500 font-bold cursor-pointer uppercase dark:text-primary-400 hover:underline">
                {{ 'or' | t }} 
              </span>
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
            </div>
                              <div
              class="border pt-4 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="amount" class="bg-white text-gray-700 px-1">{{ $t('amount') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="amount" autocomplete="false" tabindex="0" type="text" v-model="amount"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
                        </div>

                        <div class="font-semibold" position="left"> {{ 'methods' | t }} </div>
                        <div class="flex flex-wrap p-1 content-start m-auto md:w-11/12 w-full" id="methods_scroll">
                            <div v-for="(item, index) in methods" :key="index" class="md:p-2 p-1 md:w-1/3 w-1/2 mb-2" >
                                <div class="card_method md:p-2 p-4 text-center relative" :id="'methods_scroll'+item._id" :class="{ 'active': item._id == method._id }" @click="setMethod(item)" >
                                    <div class="overflow" ></div>
                                    <img :src="item.logo" class="w-full h-12"  style="object-fit: contain;" >
                                    <!-- <div class="h-5" ></div> -->
                                    <!-- <span class="text-secondary font-medium capitalize truncate text-center" > {{ item.name | t }} </span> -->
                                </div>
                            </div>
                        </div>
                        <div class="m-auto md:w-11/12 w-full p-1" v-if="method.name == 'transfer'" >
                            <div :color="'primary'" active="true">
                                <div class="flex flex-col w-full p-2" >
                                    <div class="mb-2" >
                                        <b class="text-sm" >RIB :</b>  <span class="text-secondary pl-2 tracking-wider" style="letter-spacing: .2em;" >230021639949222101850036</span>
                                    </div>
                                    <div class="mb-2">
                                        <b class="text-sm">BANK :</b>  <span class="text-secondary pl-2" >CIH BANK ( N° de compte : 6399492221018500)</span>
                                    </div>
                                    <div class="mb-2">
                                        <b class="text-sm">Nom :</b>  <span class="text-secondary pl-2" >Storeino</span>
                                    </div> 
                                    <small class="text-secondary">Vous devez nous envoyer une copie de l'ordre du virement par mail vers contact@vex.ma ou sur whatsapp +212661372852</small>
                                </div>
                            </div>
                        </div>
                        
                        <div position="left"> </div>
                        <div class="flex w-full items-center justify-end" >
                            <button 
                            class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
                            @click="onSubmit"> {{'pay' | t}} </button>
                        </div>
                    </div>
                </div>

                <div class="md:w-5/12 w-full md:p-2 p-1 mb-3">
					<div class="bg-white shadow rounded">
						<div class="flex flex-nowrap p-4 items-center justify-between border-0 border-b border-solid border-grey-light">
							<h5 class="text-secondary">{{ "balance_histories" | t }}</h5>
						</div>
						<ul class="listHistories">
                            <li v-for="(item, index) in transactions" :key="index" class="p-1 my-2">
                                <div class="rounded shadow bg-white flex flex-wrap" > 
                                    <div class="w-full flex justify-between px-3 mt-3" > 
                                      <p class="text-secondary uppercase font-medium">{{  item.type }}</p>   
                                        <p :class="{'text-green':item.status == 'complete','text-orange':item.status == 'pending'}" class="px-2 rounded-lg">{{item.status}}</p>
                                    </div>
                                    <div class="font-semibold w-full px-3 mt-1">
                                       <b :class="{'text-green' : item.type == 'charge', 'text-red' : item.type == 'pay' }" >
                                         {{ item.type == 'pay' ? '-' : '+' }}  {{ item.amount }} USD
                                        </b> 
                                        <!-- <small class="text-xs text-secondary">{{ balance.currency }}</small> -->
                                    </div>
                                    <div class="bg-light px-3 py-2 w-full rounded flex items-center justify-between mt-1" >
                                        <div class="text-medium flex items-center" >
                                            <template v-if="item.method">
                                               <span class="pl-2 text-sm font-medium text-secondary"> {{ item.method }}  </span> 
                                            </template>
                                        </div>
                                        <div class="text-sm" > {{ $moment(item.createdAt).format('yyyy-MM-DD HH:mm') }} </div>
                                    </div>
                                </div>
                            </li>
						</ul>
					</div>
				</div>
            </div>
        </div>
        <!-- <vs-prompt :accept-text="'confirm' | t"  :title="'popup_title' | t"  :active.sync="activePopUpPrompt">
                <div class="con-exemple-prompt flex flex-wrap">
                    <div class="w-full flex flex-wrap mb-2 p-1">
                        {{ $t("popup_text") }}
                        <br><a :href="approveLink" target="_blank" >{{ $t("popup_approveLink") }}</a>
                    </div>
                </div>
        </vs-prompt>
        <vs-popup :title="'balance_histories' | t" :active.sync="isActivePopup">
            <div class="container p-0" >
                <div class="bg-white rounded">
                    
                    <ul v-if="selectedBalance.history && selectedBalance.history.length > 0" class="w-full">
                        <li v-for="(item, index) in selectedBalance.history" :key="index" class="p-1 my-2">
                            <div class="rounded shadow bg-white flex flex-wrap" > 
                                <div class="text-secondary w-full uppercase font-medium px-3 mt-3" > {{  item.name }} </div>
                                <div class="font-semibold w-full px-3 mt-1">
                                    <b :class="{'text-success' : item.type == 'debit', 'text-danger' : item.type == 'credit' }" >
                                        {{ item.type == 'credit' ? '-' : '+' }}  {{ item.amount }} 
                                    </b> 
                                    <small class="text-xs text-secondary">{{ balance.currency }}</small>
                                </div>
                                <div class="bg-light px-3 py-2 w-full rounded flex items-center justify-between mt-1" >
                                    <div class="text-medium flex items-center" >
                                        <template v-if="item.method">
                                            <feather-icon icon="CreditCardIcon" svgClasses="w-4 h-4 text-secondary" />
                                            <span class="pl-2 text-sm font-medium text-secondary"> {{ item.method }}  </span> 
                                        </template>
                                    </div>
                                    <div class="text-sm" > {{ item.date | date }} </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="w-full flex items-center justify-center h-32" >
                        <p class="text-grey font-medium text-lg" > No Historie found </p>
                    </div>
                </div>
            </div>
        </vs-popup> -->
        <!-- <vs-prompt :title="''" :color="'success'" buttons-hidden @cancel="paymentAlert.isActive = false" @accept="paymentAlert.isActive = false" @close="paymentAlert.isActive = false" :active.sync="paymentAlert.isActive">
            <div class="con-exemple-prompt mb-5">
                <div v-if="paymentAlert.type == 'success'" class="flex items-center flex-col justify-center" >
                    <span class="font-semibold text-grey text-sm mb-4"> CachPlus payments code </span>
                    <span class="font-semibold text-danger text-lg"> {{ paymentAlert.token }} </span>
                </div>
            </div>
        </vs-prompt> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            paymentAlert:{
                isActive : false,
                type: "success",
                token: ''
            },
            loading: {
                page: true,
                companies:true,
                submit: false
            },
            method: {
                _id: null,
                name: null,
            },
            amount: 5,
            methods: [
    {
        "logo": "https://storeino.b-cdn.net/assets/others/banktransfer.png",
        "isOnline": false,
        "isActive": true,
        "_id": "5ff306b790987feb5d2cfbc2",
        "name": "transfer"
    },
    {
        "logo": "https://storeino.b-cdn.net/assets/others/paypal.png",
        "isOnline": true,
        "isActive": true,
        "_id": "5ff306b790987feb5d2cfbc7",
        "name": "paypal"
    },
    {
        "logo": "https://storeino.b-cdn.net/assets/others/visa-and-mastercard-Card-international.png",
        "isOnline": true,
        "isActive": true,
        "_id": "612a2e426e96988cc72aa962",
        "name": "stripe"
    },
    {
        "logo": "https://storeino.b-cdn.net/assets/others/visa-and-mastercard_morroco.png",
        "isOnline": true,
        "isActive": true,
        "_id": "6213ac9bb8cdfae5ee920fd2",
        "name": "cmi"
    }
],
            histories:[],
            balance:{},
            transactions: [],
            approveLink:null,
            activePopUpPrompt:false,
            indexPage : 0,
            param: {
                populate: {
                  path: "sellerId",
                  model: "users"
                },
                limit: 24,
                page: 1,
                sort :{
                    balance:-1
                }
            },
            pagination:{},
            ischangepaginate: false,
            isActivePopup:false,
            selectedBalance : {}
        }
    },
    created() {
        this.init();
    },
    computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		currenPage: {
			get: function() {
				return this.param.page ? parseInt(this.param.page) : 1;
			},
			set: function(newValue) {
				if (this.ischangepaginate) {
					this.$emit("paginate", newValue);
                    this.param.page = newValue;
                    this.getTransactions();
					this.ischangepaginate = false;
				}
			},
		},
	},
    watch:{
        'loading.transactions':function(val){
			if (val) {
				this.$vs.loading({
					container: '#balances-with-loading',
					scale: 0.6
				});
			} else {
				this.$vs.loading.close('#balances-with-loading > .con-vs-loading');
			}
        },
        indexPage : function(val){
            if (val == 1 && this.transactions.length == 0) {
                this.getTransactions();
            }
        }
    
    },
    methods: {
        changePaginate() {
			this.ischangepaginate = true;
		},
        async init(){
            await this.getBalance();
            await this.getTransactions()
            await this.getMethods();
        },
        async getTransactions(){
            this.loading.transactions = true;
            try {
                const response = await this.$server.search(`/transactions`);
				this.transactions = response.content.results;
                this.pagination = response.content.paginate;
                this.loading.transactions = false;
            } catch (error) {
                this.loading.transactions = false;
                console.log(error);
            }
        },
        viewBalance(company){
            this.selectedBalance = company;
            this.isActivePopup = true;
        },
        async getBalance(){
            try {
                const response = await this.$server.get(`/wallets`);
                if(response.status == 404) return this.createBalance();
				this.balance =  response.content.balance;
            } catch (error) {
                console.log(error.response.status);
                if (error.response && error.response.status == 404) this.createBalance();
                console.log(error);
            }
        },
        async createBalance(){
            try {
                const response = await this.$server.create(`/wallets`,{});
                console.log(response);
				this.balance =  response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getMethods() {
            try {
               
                let sortingArr = ['amanpay-card','paypal','transfer','amanpay-cash','amanpay-amanty'];
                this.methods.sort(function(a, b){  
                    return sortingArr.indexOf(a.name) - sortingArr.indexOf(b.name);
                });
                this.$_.remove(this.methods, function (el) {
                    return ['balance'].includes(el['name']);
                });
                if (typeof(this.$store.getters.user.country) != "undefined"  && this.$store.getters.user.country.code != "MA" && !this.$store.getters.isAdmin) {
                    let listMeth = ['transfer','amanpay-cash','amanpay-amanty','amanpay-card'];
                    this.$_.remove(this.methods, function (el) {
                        return listMeth.includes(el['name']);
                    });
                }
                this.method.name = this.methods[0].name;
                this.method._id = this.methods[0]._id;
            } catch (error) {
                console.log(error.response);
            }
        },
        setMethod(item){
            this.method.name = item.name;
            this.method._id = item._id;
            const methodsID = document.getElementById(`methods_scroll${this.method._id}`);
            methodsID.scrollIntoView({ block: 'center',behavior: 'smooth'});
        },
        isInvalidBalance(){
            let isValid = true;
            if (this.amount < 5) isValid = false;
            return isValid;
        },
        async onSubmit(){
            if (this.isInvalidBalance() && this.method.name) {
                this.loading.submit = true;
                let body = {
                    amount : this.amount,
                    method : JSON.parse(JSON.stringify(this.method.name))
                };
                const url = `/wallets`;
                try {
                    const response = await this.$server.balanceCharge(url,body);
                    // this.$vs.notify({ title: 'Success', text: "succefully", color: "success", position: 'bottom-center', iconPack: 'feather', icon: 'icon-check' });
                    if (typeof response.content.payment.paymentResponse.approveLink != 'undefined') {
                        console.log(response.content.payment.paymentResponse.approveLink)
                        var newWin = window.open(response.content.payment.paymentResponse.approveLink,'_blank');
                        if(!newWin || newWin.closed || typeof newWin.closed=='undefined'){ 
                            //POPUP BLOCKED
                            // console.log('------------------------ POPUP BLOCKED --------------------------');
                            this.approveLink = response.content.payment.paymentResponse.approveLink;
                            this.activePopUpPrompt = true;
                        }
                    }
                    else if(typeof response.content.payment.paymentResponse.token != 'undefined'){
                        this.paymentAlert.isActive = true;
                        this.paymentAlert.token = response.content.payment.paymentResponse.token;
                    }
                    this.loading.submit = false;
                    // this.$store.dispatch("getInit");
                    console.log(response.content);
                } catch (error) {
                     this.loading.submit = false;
                    // this.$vs.notify({ title: 'Error', text: "Error", color: "danger", position: 'bottom-center', iconPack: 'feather', icon: 'icon-alert-circle' });
                    return 0;
                }

            }
        }
    },
}
</script>

<style>
    .text-green{
        color:#14ad14
    }
    .text-red{
        color:#ad1414
    }
    .text-green-300{
        color:#8ae08a
    }
    .text-orange{
        color:#e39300
    }
    .listHistories{
        height: 24rem;
		overflow-y: auto;
		background: rgb(242 242 242);
    }
    .cp_item{
        color: #8d8d8d;
        transition: 300ms;
        cursor: pointer;
        border: 1px solid rgb(228, 228, 228);
        background: rgb(249,249,249);
        border-radius: 0.2rem;
    }
    .cp_item:hover{
        background: rgba(var(--vs-primary),0.2);
        border: 1px solid rgba(var(--vs-primary),.6);
    }
    .card_method{
  cursor: pointer;
  border: 1px solid rgb(214, 214, 214);
  background: rgba(114, 103, 240,0.0);
  color: rgb(141, 141, 141);
  transition: 300ms;
  border-radius: 0.2rem;
}
.card_method:hover{
  cursor: pointer;
  border: 1px solid rgba(206, 206, 206, 0.9);
  background: rgba(206, 206, 206, 0.6);
    color: rgb(141, 141, 141);
  transition: 300ms;
  border-radius: 0.2rem;
}
.card_method.active{
  cursor: pointer;
  border: 1px solid rgba(92,150,252, 0.9);
  background: rgba(92,150,252, 0.6);
  color: rgb(255, 255, 255) !important;
  transition: 300ms;
  border-radius: 0.2rem;
}
    .icon_view{
        background: rgba(var(--vs-primary),.1);
    }
    .icon_view .unicon{
        fill: rgba(var(--vs-primary),.6);
    }
    
    .nav_item{
        color: #8d8d8d;
        transition: 300ms;
        cursor: pointer;
        border: 1px solid #d6d6d6;
        background: rgb(255, 255, 255);
        border-radius: 0.2rem;
    }
    .nav_item:hover {
        cursor: pointer;
        border: 1px solid #d6d6d6;
        background: rgba(255, 255, 255, 0.234);
        border-radius: 0.2rem;
    }
    .nav_item.active{
        color: white !important;
        transition: 300ms;
        cursor: pointer;
        border: 1px solid rgba(92, 150, 252, 0.9);
        background: rgba(92, 150, 252, 0.6);
    }
</style>